import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subscription } from 'rxjs';
import { AppSettings } from 'src/app/services/constants/constants';
import { CartService } from 'src/app/services/dhukan/cart.service';

import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';

@Component({
  selector: 'app-customerinfo',
  templateUrl: './customerinfo.component.html',
  styleUrls: ['./customerinfo.component.css']
})
export class CustomerinfoComponent implements OnInit {
  dinetype: String = ""

  saveloading: boolean;
  //Save Validation
  submitted: boolean;
  successfully: boolean;

  cartBO: any = {};
  cartColl: any = [];
  cartView: any = {};


  customerBO: any = {};
  customerAddressColl: any = [];
  customerView: any = {};

  isexitingaddress: boolean = false

  selectaddressid: any = 0;

  // @Input() productid: number = 0

  // @Input() productBO: any = {}

  // @Input() variationColl: any = []


  custmername: any = "";
  mobile: any = "";

  selectvariation: any = ""

  isreadonlynamemobile:boolean=false

  customerform = new FormGroup({
    customername: new FormControl('', Validators.required),
    mobile: new FormControl('', [Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]),
    houseno: new FormControl(''),
    street: new FormControl(''),
    address: new FormControl(''),
    pincode: new FormControl(''),
    areacity: new FormControl(''),
  });


  @Output() emitData = new EventEmitter();

  _routerCartSub = Subscription.EMPTY;
  _routerCustomerSub = Subscription.EMPTY;

  constructor(private appService: DhukanDataService, public router: Router, private loginService: LoginDataService,
    private productFindService: NgbModal, private cartservice: CartService, private activeModal: NgbActiveModal) {

    if (AppSettings.appname === "QRTAKEAWAY") {
      this.dinetype = "TAKEAWAY";
    }
    else if (AppSettings.appname === "QRDINEIN") {
      this.dinetype = "DINEIN";
    }
    else if (AppSettings.appname === "QRDELIVERY") {
      this.dinetype = "DELIVERY";
    }

    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.cartView = this.cartservice.cartView;
    this._routerCartSub = this.cartservice.servicecartChange.subscribe((value) => {
      this.cartView = value
      if (this.cartView.cartmain) {
        this.cartBO = this.cartView.cartmain
      }
      if (this.cartView.cartdetails) {
        this.cartColl = this.cartView.cartdetails
      }

    });

    this._routerCustomerSub = this.loginService.servicecustomerChange.subscribe((value) => {
      this.customerView = value
      if (this.customerView.customermain) {
        this.customerBO = this.customerView.customermain
        this.customerAddressColl = this.customerView.customeraddress
      }
    });


  }


  ngOnInit() {


    this.cartView = this.cartservice.cartView;
    if (this.cartView.cartmain) {
      this.cartBO = this.cartView.cartmain
    }
    if (this.cartView.cartdetails) {
      this.cartColl = this.cartView.cartdetails
    }
    this.cartView = this.cartservice.cartView;


    this.customerView = this.loginService.customerView
    if (this.customerView.customermain) {
      this.customerBO = this.customerView.customermain
      this.customerAddressColl = this.loginService.customerAddressColl
    }
    //console.log(this.loginService.customerAddressColl)

    this.fnInitializeCustomerForm()
  }

  ngOnDestroy(): void {
    if (this._routerCartSub !== undefined) {
      this._routerCartSub.unsubscribe();
    }

    if (this._routerCustomerSub !== undefined) {
      this._routerCustomerSub.unsubscribe();
    }


  }


  fnInitializeCustomerForm() {
    this.customerform.setValue({
      customername: null,
      mobile: null,
      houseno: null,
      street: null,
      address: null,
      pincode: null,
      areacity: null
    })

    if (this.dinetype === "DELIVERY") {
      this.isreadonlynamemobile=true;
      
      this.customerform.controls['houseno'].setValidators(Validators.required);
      this.customerform.controls['street'].setValidators(Validators.required);
      this.customerform.controls['address'].setValidators(Validators.required);
      this.customerform.controls['pincode'].setValidators(Validators.required);
      this.customerform.controls['areacity'].setValidators(Validators.required);

      if (this.customerBO.partyid > 0) {
        this.customerform.patchValue({
          customername: this.customerBO.partyname,
          mobile: this.customerBO.mobileno,
        })

        if (this.customerAddressColl.length > 0) {
          this.fnAddressRowBtnClick(this.customerAddressColl[0])
          this.isexitingaddress = true
        }


      }
    }

  }

  public fnProceedBtnClick() {
    try {

      if (this.saveloading) {
        return;
      }

      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.customerform.valid) {
        this.saveloading = true;
        var data = {
          'customername': this.customerform.get('customername').value,
          'mobile': this.customerform.get('mobile').value,
          'remarks': '',
          'houseno': this.customerform.get('houseno').value,
          'street': this.customerform.get('street').value,
          'address': this.customerform.get('address').value,
          'pincode': this.customerform.get('pincode').value,
          'areacity': this.customerform.get('areacity').value
        }
        this.emitData.emit(data);
        this.activeModal.close(false);
      }
      else {
        //console.log(this.customerform)
        this.saveloading = false;
      }
    } catch (ex) {
      this.saveloading = false;
      this.fnShowErrorMsg(ex);
    }

  }

  public decline() {


    this.activeModal.close(false);
  }


  fnAddressRowBtnClick(abo) {

    this.customerform.patchValue({
      houseno: abo.doorno,
      street: abo.street,
      address: abo.area,
      pincode: abo.pincode,
      areacity: abo.city
    })

    this.isexitingaddress = true

    this.selectaddressid = abo.partyaddressid
  }

  fnNewAddressBtnClick() {

    this.isexitingaddress = false
    this.selectaddressid = 0;

    this.customerform.patchValue({
      houseno: null,
      street: null,
      address: null,
      pincode: null,
      areacity: null
    })


  }

  private fnShowErrorMsg(ex) {
    console.log(ex)
    //this.toastr.warning('Internal Error', ex);
  }



}
